module.exports = __webpack_public_path__ + "img/clients.14125748.svg";